import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-analytics',
    templateUrl: './analytics.component.html',
    styleUrls: ['./analytics.component.scss'],
    standalone: false
})
export class ReportsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
